import { render, staticRenderFns } from "./AamsGiftRegUsageApproval.vue?vue&type=template&id=7deeabd1&scoped=true&"
import script from "./AamsGiftRegUsageApproval.vue?vue&type=script&lang=js&"
export * from "./AamsGiftRegUsageApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7deeabd1",
  null
  
)

export default component.exports